module.exports = __webpack_public_path__ + "media/vid1b.3d894c76.mp4";